export const IS_INTERESTED_IN_PV = 'interestInPv';
export const IS_INTERESTED_IN_HEAT_PUMP = 'interestInHeatPump';
export const IS_INTERESTED_IN_WALLBOX = 'interestInWallBox';
export const IS_INTERESTED_IN_STROM_WALLET = 'interestInStromWallet';
